// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"46ed1c80","225":"5a418291","309":"8d991460","472":"cd1f5c07","533":"c80f3ed2","761":"41ad5895","765":"55649226","824":"60b24806","879":"a76cba8c","918":"b97d5677","937":"cc389887"}[chunkId] + ".chunk.js";
};